/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from "react";
import BannerCriticalDesktop from "./BannerCriticalDesktop";
import BannerCriticalMobile from "./BannerCriticalMobile";
import { MobileContext } from "../wrappers/withMobile";

const BannerCritical = (props) => {
  const { isMobile } = useContext(MobileContext);
  return isMobile ? (
    <BannerCriticalMobile {...props} />
  ) : (
    <BannerCriticalDesktop {...props} />
  );
};

export default BannerCritical;
